import React, { Component } from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import './compiled/FormElement.css';
import { getId } from './util';

class FormElement extends Component {
  // Constructor
  constructor(props) {
    super(props);

    this.inputId = getId();

    this.state = {
      is_dirty: false
    };
  }

  // Handlers
  handleChange = e => {
    let target = e.target;
    let value = target.value;
    this.setState({ is_dirty: true });
    this.props.onChange(e, value);
  };

  handleKeyDown = e => {
    // move between fields:
    //
    // *   arrow up or down should go to next field if at beginning
    //     or end of field (respectively)
    // *   enter/return should go to next field (if not a textarea)
    //
    let keys = getKeys(e);

    if (this.props.onNext) {
      let trigger = false;
      let input = e.target;

      if (keys.vertical) {
        let start = input.selectionStart;
        let end = input.selectionEnd;

        trigger =
          start === end &&
          ((keys.up && start === 0) ||
            (keys.down && start === input.value.length));
      } else if (keys.enter) {
        trigger = input.nodeName.toUpperCase() !== 'TEXTAREA';
      }

      if (trigger) {
        e.preventDefault();
        this.props.onNext(e, keys.up, keys.enter);
      }
    }
  };

  handleFocus = e => {
    if (this.props.onFocus) {
      this.props.onFocus(e);
    }
  };

  // Triggers
  triggerFocus = () => {
    let input = this.input;

    // handle TextareaAutosize
    if (input.textarea) {
      input = input.textarea;
    }

    input.focus();
  };

  // Helpers

  // Render
  render() {
    let props = this.props;

    let title = props.title;
    let name = props.name;
    let help = props.help;
    let placeholder = props.placeholder;
    let value = props.value || '';
    let type = props.type || FIELD_TYPES.text;
    let is_valid = validate(props, props.value);
    let is_dirty = this.state.is_dirty || props.is_dirty;

    // NOTE - using "off" doesn't really work
    // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion#Disabling_autocompletion
    let autocomplete = _ifundef(props.autocomplete, true) ? 'on' : 'nope';

    let required_elt = props.optional ? null : (
      <span className="required">*</span>
    );

    let input_elt =
      type === FIELD_TYPES.textarea ? (
        <TextareaAutosize
          ref={node => (this.input = node)}
          id={this.inputId}
          className="u-full-width input"
          name={name}
          value={value}
          placeholder={placeholder}
          autoComplete={autocomplete}
          disabled={props.is_disabled}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          onFocus={this.handleFocus}
        />
      ) : (
        <input
          ref={node => (this.input = node)}
          id={this.inputId}
          className="u-full-width input"
          type={type}
          name={name}
          value={value}
          placeholder={placeholder}
          autoComplete={autocomplete}
          disabled={props.is_disabled}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          onFocus={this.handleFocus}
        />
      );

    return (
      <div
        className={`FormElement
          ${is_valid ? 'valid' : 'invalid'}
          ${is_dirty ? 'dirty' : 'clean'}`}
      >
        <label title={props.optional ? '' : 'This field is required'} htmlFor={this.inputId}>
          {title}
          {required_elt}
        </label>
        <p className={`help ${help ? '' : 'hide'}`}>{help}</p>
        {input_elt}
      </div>
    );
  }
}

export const FIELD_TYPES = {
  text: 'text',
  textarea: 'textarea',
  email: 'email'
};

// export const makeField = (id, title, help, extra) => {
//   return Object.assign({ title: '' }, extra, { id, title, help });
// };

export const getKeys = e => {
  let code = e.keyCode;
  return {
    up: code === 38,
    down: code === 40,
    left: code === 37,
    right: code === 39,
    vertical: code === 38 ? -1 : code === 40 ? 1 : 0,
    horizontal: code === 37 ? -1 : code === 39 ? 1 : 0,
    enter: code === 13,
    esc: code === 27
  };
};

export const validate = (field, value) => {
  // if not optional, do not allow blank fields (or white space either)
  if (!field.optional && (!value || !value.trim())) {
    return false;
  }
  return true;
};

const _ifundef = (x, default_val) => (x === undefined ? default_val : x);

export default FormElement;
